var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1001 1001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.542 625.625h583.916V208.542H208.542v417.083zm625.625-500.5H166.833c-23.064 0-41.708 18.685-41.708 41.708v500.5c0 23.023 18.644 41.709 41.708 41.709h166.834l-75.075 100.1c-13.847 18.435-10.094 44.586 8.341 58.391a41.462 41.462 0 0 0 24.984 8.342c12.72 0 25.233-5.756 33.408-16.683l112.613-150.15h20.854v125.125c0 23.023 18.643 41.708 41.708 41.708 23.065 0 41.708-18.685 41.708-41.708V709.042h20.855l112.612 150.15c8.175 10.927 20.687 16.683 33.408 16.683a41.462 41.462 0 0 0 24.984-8.342c18.435-13.805 22.189-39.956 8.341-58.391l-75.075-100.1h166.834c23.064 0 41.708-18.686 41.708-41.709v-500.5c0-23.023-18.644-41.708-41.708-41.708z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormation);
export default __webpack_public_path__ + "static/media/formation.7632e481db8e5eab79c5b267c610e966.svg";
export { ForwardRef as ReactComponent };